import { SVGProps, Ref, forwardRef } from 'react';

export const BagPlusFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1c3.208 0 4.889 2.288 5.59 5.231 1.817.16 3.624.4 5.41.716L22 10l1 13H1l1-13-1-3.053a62 62 0 0 1 5.408-.716C7.11 3.288 8.792 1 12 1m-.9 12.6H8v1.8h3.1v3.1h1.8v-3.1H16v-1.8h-3.1v-3.1h-1.8zM12 2.8c-1.502 0-2.446.683-3.114 1.887-.23.414-.423.887-.58 1.407a64 64 0 0 1 7.386 0 7 7 0 0 0-.578-1.407C14.446 3.483 13.502 2.8 12 2.8"
            fill="currentColor"
        />
    </svg>
));
BagPlusFilledSize24Glyph.displayName = 'BagPlusFilledSize24Glyph';
